import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { toastError, toastSuccess } from '@components/Toast';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import ApiClient from '@lib/apiClient';

const ImageTab = ({ id }) => {
	const [documentList, setDocumentList] = useState([]);
	const dispatch = useDispatch();

	useEffect(() => {
		fetchProductInfo(id);
	}, [id]);

	const fetchProductInfo = async () => {
		dispatch(openLoader());
		await ApiClient.GET('fetchProductInfo', id)
			.then((response) => {
				setDocumentList(response?.data?.allImageDocuments);
				dispatch(closeLoader());
			})
			.catch((error) => {
				dispatch(closeLoader());
				if (error.message) {
					toastError(error.message);
				} else {
					toastError('Something went wrong! Please try again.');
				}
			});
	};

	const onFileUpload = async (fileData) => {
		try {
			const { data } = await ApiClient.POST('uploadProductDocument', fileData, id);
			toastSuccess(data.message);
			if (data.success) {
				await fetchProductInfo();
			}
			dispatch(closeLoader());
		} catch (error) {
			dispatch(closeLoader());
			if (error.message) {
				toastError(error.message);
			} else {
				toastError('Something went wrong! Please try again.');
			}
		}
	};

	const onImageUpload = async (e) => {
		dispatch(openLoader());
		let files = [];
		files = [...e.target.files];
		const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];
		let allFileList = [];
		await files.forEach((file) => {
			if (file) {
				let data = {
					name: file?.name,
					docMimeType: file?.type === '' ? 'application/octet-stream' : file?.type,
					documentType: !allowedTypes.includes(file.type) ? 'PRODUCT_NOT_IMAGE' : 'REFERENCE_IMAGE',
					base64Str: ''
				};
				let reader = new FileReader();
				reader.readAsDataURL(file);
				reader.onload = () => {
					data.base64Str = reader.result;
					allFileList.push(data);
				};
				reader.onerror = function (error) {
					toastError(error);
				};
			}
		});
		setTimeout(() => {
			onFileUpload(allFileList);
		}, 100);
	};

	const onDeleteImage = async (docId) => {
		dispatch(openLoader());
		await ApiClient.DELETE('deleteProductDocument', {}, `${id}/${docId}`)
			.then(() => {
				fetchProductInfo();
				dispatch(closeLoader());
			})
			.catch(({ response }) => {
				dispatch(closeLoader());
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Request was unsuccessful.');
				}
			});
	};

	return (
		<div className="similar-styles-section" id="blockScroll">
			<div className="design-list-container">
				<div className="d-flex align-items-center mt-2">
					<div className="text-view-uploader upload-template w-100 pb-2">
						<label htmlFor="blockImage" className="drag-upload cursor-pointer">
							<p className="regular-14 gray_dark_01">Upload</p>
						</label>
						<input
							type="file"
							className="file-upload d-none"
							name="blockImage"
							id="blockImage"
							accept="image/jpeg', 'image/png', 'image/jpg"
							onClick={(e) => (e.target.value = null)}
							onChange={(e) => onImageUpload(e)}
							multiple={true}
						/>
					</div>
				</div>
				<div id="nitex__app" className="bg-white">
					<div className="file-preview">
						{documentList?.map((item) => (
							<div className="single-image-preview" key={item.id}>
								<div className="single-design-card with-editable ">
									<div className="card-top">
										<div className="edit-items">
											<div className="dropdown">
												<span
													className="more dropdown-toggle"
													id="menu1"
													data-toggle="dropdown"
													aria-expanded="false"
												>
													<img
														src={`${process.env.PUBLIC_URL}/icons/more_icon.svg`}
														alt="more"
													/>
												</span>
												<ul
													className="dropdown-menu dropdown-menu-right shadow-lg"
													role="menu"
													aria-labelledby="downloadType"
													x-placement="bottom-end"
												>
													<li onClick={() => onDeleteImage(item.id)}>
														<span>Delete</span>
													</li>
												</ul>
											</div>
										</div>

										<span>
											<img
												src={item?.docUrl}
												className="card-image"
												alt="product-image"
											/>
										</span>
									</div>
								</div>
							</div>
						))}
					</div>
				</div>
			</div>
		</div>
	);
};

export default ImageTab;
